module.exports = __webpack_public_path__ + "img/homefooter_icon03.2e7f0fbd.png";